import { Routes } from '@angular/router';
import { authGuard, authVerifiedGuard } from './auth-guard';
import { AcceptInviteComponent } from './modules/invite-link/accept-invite/accept-invite.component';
import { LayoutComponent } from './modules/layout/layout/layout.component';
import { VerifyEmailComponent } from './modules/login/verify-email/verify/verify-email.component';
import { PageNotFoundComponent } from './modules/public/page-not-found/page-not-found.component';
import { UserLoginComponent } from './modules/login/user-login/user-login.component';

// level: /
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./modules/landing/landing.component').then(
        (m) => m.LandingComponent
      ),
  },
  {
    path: 'landing',
    loadComponent: () =>
      import('./modules/landing/landing.component').then(
        (m) => m.LandingComponent
      ),
  },
  {
    path: 'auth',
    component: UserLoginComponent,
  },
  {
    path: 'login',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: 'invite', // under construction
    component: AcceptInviteComponent,
  },
  {
    path: 'app',
    component: LayoutComponent,
    canActivate: [authGuard, authVerifiedGuard],
    loadChildren: () =>
      import('./modules/layout/layout/layout.routes').then(
        (module) => module.layoutRoutes
      ),
  },
  {
    path: 'verify-email',
    component: VerifyEmailComponent,
    canActivate: [authGuard],
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./modules/login/login.routes').then((m) => m.routes),
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./modules/public/public.routes').then((m) => m.routes),
  },
  { path: '**', component: PageNotFoundComponent },
];
